import i18n from 'src/providers/i18n-provider'
import * as Yup from 'yup'

export const passwordSchema = Yup.string()
  .required(i18n.t('validation-required'))
  .min(8, 'validation-password-min')
  .matches(/[0-9]/, 'validation-password-regexp')
  .matches(/[a-z]/, 'validation-password-regexp-1')
  .matches(/[A-Z]/, 'validation-password-regexp-2')
  .matches(/[^\w]/, 'validation-password-regexp-3')
  .max(250, 'validation-password-max')
